var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31267 4.64592C2.35911 4.59935 2.41429 4.56241 2.47503 4.5372C2.53578 4.512 2.6009 4.49902 2.66667 4.49902C2.73243 4.49902 2.79755 4.512 2.8583 4.5372C2.91904 4.56241 2.97422 4.59935 3.02067 4.64592L8.66667 10.2929L14.3127 4.64592C14.3592 4.59943 14.4143 4.56255 14.4751 4.53739C14.5358 4.51223 14.6009 4.49929 14.6667 4.49929C14.7324 4.49929 14.7975 4.51223 14.8582 4.53739C14.919 4.56255 14.9742 4.59943 15.0207 4.64592C15.0672 4.6924 15.104 4.74759 15.1292 4.80833C15.1543 4.86907 15.1673 4.93417 15.1673 4.99992C15.1673 5.06566 15.1543 5.13076 15.1292 5.1915C15.104 5.25224 15.0672 5.30743 15.0207 5.35392L9.02067 11.3539C8.97422 11.4005 8.91904 11.4374 8.8583 11.4626C8.79755 11.4878 8.73243 11.5008 8.66667 11.5008C8.6009 11.5008 8.53578 11.4878 8.47503 11.4626C8.41429 11.4374 8.35911 11.4005 8.31266 11.3539L2.31267 5.35392C2.2661 5.30747 2.22916 5.2523 2.20395 5.19155C2.17875 5.13081 2.16577 5.06568 2.16577 4.99992C2.16577 4.93415 2.17875 4.86903 2.20395 4.80828C2.22916 4.74754 2.2661 4.69236 2.31267 4.64592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.16fbf8c0ceb3c53c53c31da48a86b34e.svg";
export { ForwardRef as ReactComponent };